import React from 'react';
import { Link } from 'react-router-dom';
import config from './../../config.json'
import './place.css';

const Place = ({title, areaName, image, placeId, score, getPlaceInfo, fetchLoading}) => {
    return (
        <div className="col-lg-4 col-sm-6 col-12 ">
            <div className="well place_view">
                <div className="col-sm-12 d-flex flex-column my-2 px-0">
                    <div className="image-layer"
                        onClick={getPlaceInfo}
                    >
                        <img src={`${config.api_server}/${image}`} alt="" className="img-fluid"/>
                    </div>
                    <div className=" p-2">
                        <h2>{title}</h2>
                        <div className="">
                            <small className="font-weight-bold">
                                <i className="fa fa-map-marker mr-1"></i>منطقه : 
                            </small>
                            <small className="ml-1">{areaName}</small>
                        </div>
                    </div>
                </div>
                <div className="col-12  d-flex flex-wrap bottom-stars px-2">
                    {
                        fetchLoading.flag && fetchLoading.id === placeId ? 
                        <div className="col-6 col-sm-6  px-0">
                            <button 
                                type="button" 
                                className="btn btn-secondary btn-sm py-0"
                                disabled={true}
                            >
                                <i  className= 'spinner-border spinner-border-sm operator-button mr-1'
                                    style={{position:'relative', top:'-4px', width:'13px', height:'13px'}}
                                ></i>
                                <span>در حال دریافت ... </span>
                            </button>
                        </div>
                        :
                        <div className="col-6 col-sm-6  px-0">
                            <button type="button" className="btn btn-primary btn-sm py-0"
                                onClick={getPlaceInfo}
                            >
                                <i 
                                    className={ fetchLoading.flag && fetchLoading.id === placeId ? 
                                    'spinner-border spinner-border-sm operator-button': 'fa fa-home mr-1'} 
                                ></i>
                                مشاهده
                            </button>
                            <button type="button" className="btn btn-success btn-sm ml-1 py-0"
                                onClick={getPlaceInfo}
                            >
                                <i className='fa fa-phone'></i>
                                <i className='fa fa-user ml-1'></i>
                            </button>
                        </div>
                    }
                    <div className="col-6 col-sm-6 px-0">
                        <p className="ratings">
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 5 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 4 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 3 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 2 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 1 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()} className="mark">{score}</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Place;